import { Colors } from "./colors";

export const palette = {
  primary: {
    main: "#305AE8",
  },
  secondary: {
    main: Colors.secondary,
  },
}